import { __rest, __assign, __awaiter, __generator } from 'tslib';
import { $gt, request } from '../packages/internals/src/app-context/host-app-context.js';
import isFunction from '../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js';
import React from 'react';
import { EllipsisTooltip } from 'ssc-ui-react';
import useRemoteSearch from '../useRemoteSearch/index.js';

var useStation = function (props) {
    var _a = props || {}, name = _a.name, labelRender = _a.labelRender, valueRender = _a.valueRender, transformer = _a.transformer, label = _a.label, columnLabel = _a.columnLabel, formItemLabel = _a.formItemLabel, url = _a.url, listKey = _a.listKey, queryKey = _a.queryKey, width = _a.width, extraParams = _a.extraParams, formItemName = _a.formItemName, formItemProps = _a.formItemProps, fieldItemName = _a.fieldItemName, ctrlProps = _a.ctrlProps, fieldCtrlProps = _a.fieldCtrlProps, formItemCtrlProps = _a.formItemCtrlProps, rules = _a.rules, required = _a.required, fetchAction = _a.fetchAction, initOptions = _a.initOptions;
    var getStationList = function (params) {
        return request.get(url !== null && url !== void 0 ? url : '/api/admin/station/dropdown/search/', { params: params }).then(function (res) { return res.data; });
    };
    var loadAction = function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (fetchAction && isFunction(fetchAction) ? fetchAction(params) : getStationList(params))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); };
    var innerTransformer = function (list) {
        return list.map(function (item) {
            var id = item.id, station_name = item.station_name;
            return {
                label: labelRender ? labelRender(item) : "".concat(station_name),
                value: valueRender ? valueRender(item) : id,
            };
        });
    };
    var _b = useRemoteSearch({
        searchFn: loadAction,
        transformer: transformer !== null && transformer !== void 0 ? transformer : innerTransformer,
        listKey: listKey !== null && listKey !== void 0 ? listKey : 'station_list',
        queryKey: queryKey !== null && queryKey !== void 0 ? queryKey : 'station_name',
        showLoading: true,
        initOptions: initOptions,
        extraParams: extraParams,
    }), loading = _b.loading, options = _b.options, handleQuerySearch = _b.handleQuerySearch, handleDebounceQuerySearch = _b.handleDebounceQuerySearch, handleDropdownVisibleChange = _b.handleDropdownVisibleChange, rest = __rest(_b, ["loading", "options", "handleQuerySearch", "handleDebounceQuerySearch", "handleDropdownVisibleChange"]);
    var stationLabel = $gt('Station');
    var baseCtrlProps = {
        allowClear: true,
        showSearch: false,
        filterOption: false,
        loading: loading,
        options: options,
        notFoundContent: loading ? React.createElement("span", null,
            $gt('Loading'),
            " ") : React.createElement("span", null, $gt('No Result')),
        onSearch: handleDebounceQuerySearch,
        onDropdownVisibleChange: handleDropdownVisibleChange,
    };
    var finalCtrlProps = __assign(__assign({}, baseCtrlProps), ctrlProps);
    var stationField = {
        name: fieldItemName || formItemName || name || 'station_id',
        label: label || stationLabel,
        type: 'select',
        ctrlProps: __assign(__assign({ onClear: function () { return handleQuerySearch(''); } }, finalCtrlProps), fieldCtrlProps),
    };
    var stationColumn = {
        title: columnLabel || label || stationLabel,
        dataIndex: name || 'station_name',
        key: name || 'station_name',
        width: width !== null && width !== void 0 ? width : 150,
        render: function (_, row) {
            var content = function () {
                if (!row[name || 'station_name'])
                    return '-';
                return labelRender ? labelRender(row) : "".concat(name ? row[name] : row.station_name);
            };
            return (React.createElement("div", { style: {
                    wordBreak: 'break-word',
                } },
                React.createElement(EllipsisTooltip, { title: content(), lines: 2, width: width !== null && width !== void 0 ? width : 150 },
                    React.createElement("span", null,
                        content(),
                        " "))));
        },
    };
    var stationFormItem = {
        type: 'select',
        // basically, the name of the form item is the same as the name of the field, but it can be customized
        name: formItemName || name || 'station_id',
        label: formItemLabel || label || stationLabel,
        required: required || false,
        rules: rules || [],
        formItemProps: formItemProps || {},
        ctrlProps: __assign(__assign({}, finalCtrlProps), formItemCtrlProps),
    };
    return __assign({ loading: loading, options: options, handleQuerySearch: handleQuerySearch, handleDebounceQuerySearch: handleDebounceQuerySearch, handleDropdownVisibleChange: handleDropdownVisibleChange, stationField: stationField, stationColumn: stationColumn, stationFormItem: stationFormItem }, rest);
};

export { useStation as default };
